import * as React from 'react'
import { ShoppingCart } from 'lucide-react'
import { Button } from '@/components/ui/button'
import { Badge } from '@/components/ui/badge'
import { useUserStore } from '../../stores/user-store'

interface NavbarCartButtonProps {
  href?: string
}

export default function NavbarCartButton({ href = '/shopping_carts/mine' }: NavbarCartButtonProps) {
  const { cartItemCount } = useUserStore()

  return (
    <Button variant="ghost" size="icon" className="relative" asChild>
      <a href={href}>
        <ShoppingCart className="!h-5 !w-5" />
        {cartItemCount > 0 && (
          <Badge
            variant="destructive"
            className="absolute -top-2 -right-2 flex h-5 w-5 items-center justify-center p-0 text-xs"
          >
            {cartItemCount}
          </Badge>
        )}
      </a>
    </Button>
  )
}
